import { http } from "@/http/http.js";
export default {
  // 扫码查询智能井盖信息
  queryWellLidInfo(params) {
    return http.post("/web/wellqrcode/queryWellLidInfo", params);
  },
};
